import React, { useState } from 'react';

// React Number Format
import NumberFormat, { NumberFormatValues } from 'react-number-format';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Styles
import '../Inputs.scss';

interface Props {
    value: number | null;
    onChange: (_value: number) => void;
    autoFocus?: boolean;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
    name?: string;
    id?: string;
    optional?: boolean;
    variant?: 'primary' | 'secondary' | 'outlined';
    md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    xs?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    className?: string;
}

const handleFormattedInputChange = ({ formattedValue: _, value, floatValue: _2 }: NumberFormatValues, onChange: (_str: number) => void) => {
    value[0] === '.' && value.replace('.', '0.');
    onChange(Number(value));
};

const AmountInput: React.FC<Props> = ({
    value,
    variant = 'primary',
    onChange,
    autoFocus = false,
    disabled = false,
    label = '',
    placeholder = '$0.00',
    name,
    optional = false,
    id,
    lg,
    md,
    xs,
    sm,
    className
}) => {
    const [ { errorMsg, inputError }, setError ] = useState({
        errorMsg: '',
        inputError: false
    });
    const [ isFocused, setIsFocused ] = useState(false);

    const validateInput = ({ formattedValue: _, value: inputValue, floatValue: _2 }: NumberFormatValues) => {
        if (optional) return;
        if (inputValue.length === 0) setError({
            inputError: true,
            errorMsg: 'Este campo es requerido'
        });
        else setError({
            inputError: false,
            errorMsg: ''
        });
    };

    return (
        <Grid
            className={`ui-AmountInput${className ? ` ${className}` : ''}`}
            item
            lg={lg}
            md={md}
            xs={xs === 1 ? undefined : xs}
            style={{
                width: xs === 1 ? '6rem' : ''
            }}
            sm={sm}
        >
            <Typography
                variant="input-head"
                className="ui-Input-label"
                color={disabled ? 'content-light' : 'primary-dark'}
            >
                {`${label}${optional ? ' (opcional)' : ''}`}
            </Typography>
            <Grid
                className="ui-Input-container"
            >
                <NumberFormat
                    className={`${variant}${(isFocused && !errorMsg) ? ' focused' : ''}${errorMsg ? ' error-border' : ''}`}
                    isNumericString
                    name={name}
                    value={value === 0 ? '' : value}
                    id={id}
                    autoFocus={autoFocus}
                    disabled={disabled}
                    placeholder={placeholder}
                    allowNegative={false}
                    decimalScale={2}
                    prefix="$"
                    thousandSeparator="."
                    decimalSeparator=","
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    onValueChange={values => {
                        handleFormattedInputChange(values, onChange);
                        validateInput(values);
                    }}
                />
            </Grid>
            { inputError && (
                <Typography
                    variant="note-regular"
                    color="error"
                    className="ui-Error-msg"
                >
                    {errorMsg}
                </Typography>
            )}
        </Grid>
    );
};

export default AmountInput;
